import { configureStore } from '@reduxjs/toolkit'
import driverReducer from '../features/drivers/driversSlice'
import rotaReducer from '../features/rota/rotaSlice'
import imagesReducer from '../features/imagesSliceFile/imagesSlice'
import scheduleReducer from '../features/schedule/scheduleSlice'
import vehicleReducer from '../features/vehicles/vehiclesSlice'
import docDriverReducer from '../features/docDrivers/docDriversSlice'
import complianceCheckReducer from '../features/compliancecheck/complianceCheckSlice'
import payrollReducer from '../features/payroll/payrollSlice'
import vanDataReducer from '../features/vanData/vanDataSlice'

export default configureStore({
  reducer: {
    driver: driverReducer,
    rota: rotaReducer,
    images: imagesReducer,
    schedule: scheduleReducer,
    vehicle: vehicleReducer,
    docDrivers: docDriverReducer,
    complianceCheck: complianceCheckReducer,
    payroll: payrollReducer,
    vanData: vanDataReducer
  },
});
